<template>
  <v-container fluid pa-0 ma-0 fill-height style="background-color: white;">
    <v-layout column wrap fill-height justify-space-between class="ma-0 pa-4 pt-5">

      <v-toolbar class="pa-0 ma-0 toolbar-padding"
                 color="white" flat dense fixed app>
        <v-btn small flat icon @click="$router.go(-1)">
          <v-icon size="24px">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
        <h3 class="display-2" style="margin-bottom: 2px">이메일 로그인</h3>
      </v-toolbar>

      <div class="pt-5 px-3 autocomplete-color">
        <v-form lazy-validation v-model="isValid">
          <v-text-field v-model="email"
                        :rules="rules.email"
                        required
                        label="Email"
                        placeholder="이메일"
                        type="email">
          </v-text-field>
          <v-text-field v-model="password"
                        :rules="rules.password"
                        required
                        label="Password"
                        placeholder="비밀번호"
                        @focus="showCounter = true"
                        @blur="showCounter = false"
                        :counter="showCounter"
                        :type="showPassword ? 'text' : 'password'"
                        :append-icon="showPassword ? '$vuetify.icons.visible' : '$vuetify.icons.invisible'"
                        @click:append="showPassword = !showPassword">
          </v-text-field>
        </v-form>
      </div>

      <div class="pb-5 px-3">
        <v-btn :disabled="!isValid"
               :loading="loading"
               block depressed color="#4a4a4a"
               class="button-style"
               style="color: white !important;"
               @click="submit">
          로그인
        </v-btn>
        <span style="cursor:pointer" @click="$router.push({ name: 'ResetPassword', query: $route.query })">비밀번호 찾기</span>
      </div>

      <div class="px-3">
        <span>새로운 계정을 만드시겠어요?</span>
        <v-btn block color="white" class="button-style button-shadow" @click="$router.replace({ name: 'EmailSignUp', query: $route.query })">이메일로 가입하기</v-btn>
      </div>

    </v-layout>

    <v-snackbar v-model="snackbar" bottom vertical :timeout="3000" auto-height>
      {{ errorMessage }}
      <v-btn color="primary" flat @click="snackbar = false">닫기</v-btn>
    </v-snackbar>

  </v-container>
</template>

<script>
  import firebase from 'firebase/app';
  import 'firebase/auth';
  import { mapActions } from 'vuex';

  export default {
    name: 'EmailLogin',
    data () {
      return {
        isValid: false,
        showPassword: false,
        showCounter: false,
        email: '',
        password: '',
        rules: {
          email: [
            v => !!v || '이메일을 입력하세요.',
            v => /.+@.+/.test(v) || '유효하지 않은 메일 주소입니다.'
          ],
          password: [
            v => !!v || '비밀번호를 입력하세요.',
          ]
        },
        loading: false,
        errorMessage: '',
        snackbar: false,
      };
    },
    methods: {
      ...mapActions('user', [ 'signUser', 'setUser', 'setJWT' ]),
      submit () {
        const root = this;
        root.loading = true;
        firebase.auth().signInWithEmailAndPassword(root.email, root.password).then(() => {
          let user = firebase.auth().currentUser;
          if (user.emailVerified) {
            user.getIdToken().then(idToken => {
              root.signUser({
                token: idToken,
                email: root.email,
                social_type: 'email'
              }).then(response => {
                console.log(response);
                root.loading = false;
                root.setJWT(response.data.token);
                root.setUser(response.data);
                root.$router.replace(root.$route.query.redirect ? root.$route.query.redirect : { name: 'Home' });
              }).catch(err => {
                console.error(err);
                root.showErrorSnackbar('오류가 발생했습니다. 잠시 후 다시 로그인해주세요.');
              });
            });
          } else {
            root.showErrorSnackbar('이메일 인증이 완료되지 않았습니다. 메일 확인 후 다시 로그인해주세요.');
          }
        }).catch(err => {
          console.error(err);
          const code = err.code;
          if (code === 'auth/user-not-found') {
            root.showErrorSnackbar('등록된 회원을 찾을 수 없습니다.');
          } else if (code === 'auth/invalid-email') {
            root.showErrorSnackbar('이메일이 올바르지 않습니다.');
          } else if (code === 'auth/wrong-password') {
            root.showErrorSnackbar('비밀번호가 다릅니다.');
          }
        });
      },
      showErrorSnackbar (message) {
        this.loading = false;
        this.errorMessage = message;
        this.snackbar = true;
      },
    },
  }
</script>

<style lang="scss" scoped>
  /deep/.toolbar-shadow .v-toolbar__content {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  /deep/.toolbar-padding .v-toolbar__content {
    padding: 0 10px 0 16px;
  }

  .button-style {
    height: 56px;
    font-size: 14px;
    letter-spacing: -0.3px;
  }
  .button-shadow {
    border: 1px solid map_get($colors, border) !important;
    box-shadow: 0 2px 4px rgba(#cdcdcd, 0.5) !important;
  }

  /deep/.autocomplete-color {
    /* Change the white to any color ;) */
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active  {
      -webkit-box-shadow: 0 0 0 30px white inset !important;
    }
    /* Change text in autofill text box */
    input:-webkit-autofill {
      /*-webkit-text-fill-color: yellow !important;*/
    }
  }
</style>
